import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const cloudGQLList = async (query, page, items) => {
   let url = `${hostCloud}/graphql`;
   query = query.replace("$page", '"' + page + '"');
   query = query.replace("$items", '"' + items + '"');
   return axios({
      method: "post",
      url: url,
      headers: {
         "Content-Type": "application/json",
         Accept: "*/*"
      },
      data: {
         query
      }
   });
};

/* 
query examples
{allDevices(jws:$token, page:$page, items:$items){ all{ id, brand, model, phoneNumber, deviceId, registerDate, requestNetworkSpeedTest, isOnline, root, ssrDeleted, ssrUpdated}}}
{device(jws:$token, body:"{\"deviceId\":1, \"day\":\"2020-05-11\"}"){single{battery{ id, capacity, deviceId, health, isPresent, level, status, syncDateTime, technology, temperature, voltage }}}}

{device(jws:$token, body:"{\"deviceId\":$sentid, \"day\":\"$date\"}"){single{battery{ id, capacity, deviceId, health, isPresent, level, status, syncDateTime, technology, temperature, voltage }}}}
{device(jws:$token, body:"{\"deviceId\":$sentid, \"day\":\"$date\"}"){single{ram{ id, deviceId, availableMemory, totalMemory }}}}
*/

/* 
{carlsbergActiveNewsletterSubscribers(id:1){id,   email,    sfaId,   agreementToSend,    agreementToSendSms,    agreementToSendEmail,    agreementToPhoneContact,    agreementToAutomaticContact,     agreementToInformationClause,    companyName,     isHoreca,     isSklep,     isHurtownik,        phoneNumber,     companyKrs,     companyNip,     companyCity,     companyRegion,     companyStreet,     companyPostCode,     companyFlatNumber,     companyHouseNumber,  timeOfRegistation,   timeOfApproval,     timeOfCancelling, externalId,  registrationEmailReceivedDate}}
{carlsbergSubscribentsWithNoAgreementToSend(newsletterId:1){id, email, sfaId,  agreementToSend, agreementToSendSms, agreementToSendEmail, agreementToPhoneContact, agreementToAutomaticContact, agreementToInformationClause, companyName, isHoreca, isSklep, isHurtownik, phoneNumber, companyKrs, companyNip, companyCity, companyRegion, companyStreet, companyPostCode, companyFlatNumber, companyHouseNumber, timeOfRegistation, timeOfApproval, timeOfCancelling, externalId, registrationEmailReceivedDate}}
{carlsbergNewsletterResignations(newsletterId:1){id, email,    sfaId,   agreementToSend,    agreementToSendSms,    agreementToSendEmail,    agreementToPhoneContact,    agreementToAutomaticContact,     agreementToInformationClause,    companyName,     isHoreca,     isSklep,     isHurtownik,  phoneNumber,     companyKrs,     companyNip,     companyCity,     companyRegion,     companyStreet,     companyPostCode,     companyFlatNumber,     companyHouseNumber,  timeOfRegistation,   timeOfApproval,     timeOfCancelling, externalId }}
*/
